/**
 * Help Center Common Utilities
 * Shared functions and data for FAQs and Tutorials
 */

(function(window) {
  'use strict';

  // Category structure definition (shared between FAQs and Tutorials)
  var categoryStructure = {
    'phone-cases': {
      label: 'Phone Cases',
      hasSubmenu: true,
      subsections: [
        { id: 'phone-cases-general', label: 'General Questions' },
        { id: 'phone-cases-edge', label: 'Edge Case' },
        { id: 'phone-cases-summa', label: 'Summa Case' },
        { id: 'phone-cases-cairn', label: 'Cairn Case' },
        { id: 'phone-cases-aaron', label: 'Aaron Case' }
      ]
    },
    'phone-gears': {
      label: 'Phone Gears',
      hasSubmenu: true,
      subsections: [
        { id: 'phone-gears-wallets', label: 'Card Wallets' },
        { id: 'phone-gears-powerbanks', label: 'Power Banks' },
        { id: 'phone-gears-carmounts', label: 'Car Mounts' },
        { id: 'phone-gears-grip', label: 'MagEZ Grip' },
        { id: 'phone-gears-straps', label: 'Phone Straps' }
      ]
    },
    'tablet-cases': {
      label: 'Tablet Cases',
      hasSubmenu: true,
      subsections: [
        { id: 'tablet-air-case', label: 'Air Case' },
        { id: 'tablet-aramid-woven', label: 'MagEZ Case 2' },
        { id: 'tablet-charging-cases', label: 'Aramid Woven Charging Cases' },
        { id: 'tablet-folio2', label: 'Folio 2' },
        { id: 'tablet-ipad-stand', label: 'iPad Stand' }
      ]
    },
    'watch-airpods': {
      label: 'Watch&Airpods Gears',
      hasSubmenu: true,
      subsections: [
        { id: 'watch-bands', label: 'Carbon Fiber Watch Bands' },
        { id: 'watch-aramid-cases', label: 'Aramid Woven Cases' },
        { id: 'airpods-cases', label: 'AirPods Cases' }
      ]
    },
    // 'shipping': { label: 'Shipping', hasSubmenu: false },
    // 'order': { label: 'Order', hasSubmenu: false },
    // 'refund-return': { label: 'Refund & Return', hasSubmenu: false }
  };

  /**
   * Get subsection IDs for a main category
   * @param {string} mainCategory - Main category ID
   * @returns {Array|null} Array of subsection IDs or null
   */
  function getSubsections(mainCategory) {
    var catData = categoryStructure[mainCategory];
    if (!catData || !catData.subsections) return null;
    return catData.subsections.map(function(sub) { return sub.id; });
  }

  /**
   * Check if a category is a main category (has subsections)
   * @param {string} categoryId - Category ID
   * @returns {boolean}
   */
  function isMainCategory(categoryId) {
    return categoryStructure[categoryId] && categoryStructure[categoryId].hasSubmenu;
  }

  /**
   * Scroll tab into view with boundary check
   * @param {HTMLElement} tab - The tab element to scroll into view
   * @param {string} logPrefix - Prefix for console logs (e.g., '[Tutorials]')
   */
  function scrollTabIntoView(tab, logPrefix) {
    logPrefix = logPrefix || '[HelpCenter]';
    var container = tab.parentElement.parentElement;

    // Get tab position relative to container
    var tabRect = tab.getBoundingClientRect();
    var containerRect = container.getBoundingClientRect();

    // Calculate the scroll position to center the tab
    var tabCenter = tabRect.left + tabRect.width / 2;
    var containerCenter = containerRect.left + containerRect.width / 2;
    var scrollOffset = tabCenter - containerCenter;

    // Calculate target scroll position
    var targetScrollLeft = container.scrollLeft + scrollOffset;

    // Get scroll boundaries
    var maxScrollLeft = container.scrollWidth - container.clientWidth;

    // Clamp to boundaries (stop at 0 or maxScrollLeft)
    targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));

    // Check if already at target position (within 1px tolerance)
    if (Math.abs(container.scrollLeft - targetScrollLeft) < 1) {
      return;
    }

    // Scroll to target position
    container.scrollTo({
      left: targetScrollLeft,
      behavior: 'smooth'
    });
  }

  /**
   * Update mobile tab active state
   * @param {NodeList} allTabs - All tab elements
   * @param {HTMLElement} activeTab - The tab to mark as active
   */
  function updateMobileTabState(allTabs, activeTab) {
    allTabs.forEach(function(tab) {
      tab.classList.remove('active', 'text-black', 'font-medium');
      tab.classList.add('text-grey');
    });
    activeTab.classList.add('active', 'text-black', 'font-medium');
    activeTab.classList.remove('text-grey');
  }

  // Expose utilities globally
  window.HelpCenterCommon = {
    categoryStructure: categoryStructure,
    getSubsections: getSubsections,
    isMainCategory: isMainCategory,
    scrollTabIntoView: scrollTabIntoView,
    updateMobileTabState: updateMobileTabState
  };

})(window);
